/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Mine_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connect external MCP servers and use their tools in your chats. A server you add is yours alone until you share it, and whoever you share it with uses it as ..." |
*
* @param {Mcp_Servers_Mine_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_mine_description = /** @type {((inputs?: Mcp_Servers_Mine_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Mine_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie externe MCP-Server und nutzen Sie deren Werkzeuge in Ihren Chats. Ein Server, den Sie hinzufügen, gehört nur Ihnen, bis Sie ihn teilen – und wer ihn dann nutzt, handelt mit dem Konto, das Sie verbunden haben.")
	return /** @type {LocalizedString} */ ("Connect external MCP servers and use their tools in your chats. A server you add is yours alone until you share it, and whoever you share it with uses it as the account you connected.")
});